<template>
  <div id="google-btns-div" />
</template>

<script>
import authService from '@/auth/Auth'
import { initializeGoogleOneTap } from '@/auth/googleAuth'

export default {
  name: 'GoogleButton',
  emits: ['error', 'success'],
  async created () {
    initializeGoogleOneTap(r => this.onLoginSuccess(r))
  },
  methods: {
    async onLoginSuccess (response) {
      try {
        await this.sendTokenToServer(response.credential)
        this.$emit('success')
      } catch (e) {
        this.$emit('error', 'Failed to login', e)
        console.error('Failed to login', e)
      }
    },
    async sendTokenToServer (token) {
      return authService.googleLogin(token)
    }
  }
}
</script>

<style lang="scss">
  div#google-btns-div > div > div > div {
    //text-transform: uppercase!important;
    font-size: 15px!important;
    font-weight: 500!important;
    letter-spacing: 0.0892857143em!important;
    height: 40px!important;
  }
  #google-btns-div {
    svg {
      width: 21px;
      height: 21px;
    }
    // GSI renders an 'outline' (white) button; recolour it to match the card
    // background and give it the same resting border as the input fields.
    [role='button'] {
      background-color: #E8E7E3 !important;
      border-color: #00000061 !important;
    }
    // Match the Microsoft button's text exactly. GSI renders the label in its
    // own grey #3c4043 (via `color` and, on newer builds, `-webkit-text-fill-color`
    // which overrides `color` for the glyphs) and its own "Google Sans" font, so
    // force colour, fill and family on every descendant. The multicolour Google
    // 'G' uses its own SVG fills, so none of these affect it.
    * {
      color: #000000DE !important;
      -webkit-text-fill-color: #000000DE !important;
      font-family: 'Roboto', sans-serif !important;
    }
  }
</style>
